import Api from "./Api";

async function generateUuid(token, data,cancelToken) {
    const response = Api.post('/api/v1/Providers/GenUuidV2', data, {
        headers: {
            "Authorization": `Bearer ${token}`
        },
        cancelToken
    });

    return response;

}

export default generateUuid;